import React from 'react';
import CrearDepositos from '../../../components/insumos/depositos/CrearDepositos';

const DepositosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <h1>Alta de Depositos</h1>
      <br />
      <br />
      <CrearDepositos />
    </div>
  );
};

export default DepositosPage;